import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { PageViewComponent } from 'projects/app-default/src/app/catalog/page/view/page-view.component';
import { NMaterialsCalcConfig } from '../materials-calculator.config';

declare module '@df/catalog/cms/cms-model.interface' {
    export interface IPageDataV3 {
        components: NICmsContentComponent.IData[];
    }
}

export namespace NMaterialCalculatorPageType {
    export const typeId = 'material-calculator';

    export interface ITypeData {
        calculatorId: string;
    }
}

@ICmsPageType({
    id: NMaterialCalculatorPageType.typeId,
    title: 'Material Calculator',
    fields: [
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'typeData.calculatorId',
            title: 'Calculator',
            options: Object.keys(NMaterialsCalcConfig.calculators).map(key => ({
                key: key,
                title: NMaterialsCalcConfig.calculators[key].title
            })),
            required: true,
            tab: 'Material Calculator'
        }
    ]
})
@Component({
    selector: 'cms-material-calculator-page',
    templateUrl: './material-calculator-cms-page.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsMaterialCalculatorPageComponent extends PageViewComponent implements OnChanges {
    @Input({ required: true })
    data!: IPageDataV3;

    @Input()
    @ICmsContent({
        watchDepth: 1
    })
    typeData?: NMaterialCalculatorPageType.ITypeData;
}
